import logo from '../assets/images/logo.png';

export function FormHeader() {
  return (
    <header className="imc-header">
      <div className="imc-logo" aria-label="International Math Competition">
        <img src={logo} alt="International Math Competition" />
      </div>
    </header>
  );
}
